export default "__VITE_ASSET__DgSEUUke__ 720w";